import { render } from "./ribbon.vue?vue&type=template&id=d307e87a"
import script from "./ribbon.vue?vue&type=script&lang=js"
export * from "./ribbon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__